"use client";
import React from "react";
import { PrismicRichText } from "@prismicio/react";
import Container from "@/components/Container";
import TitleWithDash from "@/components/TitleWithDash";
import { PrismicNextLink } from "@prismicio/next";
import EmblaCarousel from "@/slices/Testimonials/components/EmblaCarousel";

const titleComponent = {
  heading2: ({ children }) => (
    <h2 className="title-xl text-[#eeb978] title-font">{children}</h2>
  ),
  heading3: ({ children }) => (
    <h3 className="title-xl text-[#eeb978] title-font">{children}</h3>
  ),
  heading4: ({ children }) => (
    <h4 className="title-xl text-[#eeb978] title-font">{children}</h4>
  ),
};

export const bodyComponent = {
  paragraph: ({ children }) => <p className="text-base">"{children}"</p>,
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  hyperlink: ({ children, node }) => (
    <PrismicNextLink
      field={node.data}
      className="decoration-1 underline-offset-2 text-base"
    >
      {children}
    </PrismicNextLink>
  ),
};

const testimonies = ({ slice = {} }) => {
  return (
    <Container slice={slice}>
      <div className="mb-[30px] md:mb-[40px] xl:mb-[56px] relative z-[10] max-w-[80%] mx-auto text-center flex justify-center xl:block xl:mx-0">
        <TitleWithDash
          dashColor={"#c4c4c8"}
          title={
            <PrismicRichText
              components={titleComponent}
              field={slice?.primary?.title}
            />
          }
        />
      </div>
      <div className={"xl:ps-[86px]"}>
        <EmblaCarousel list={slice?.primary?.testimonials} />
        {/*<Swiper*/}
        {/*  pagination={{ clickable: true }}*/}
        {/*  modules={[Pagination]}*/}
        {/*  breakpoints={{*/}
        {/*    1200: {*/}
        {/*      slidesPerView: 2,*/}
        {/*      spaceBetween: 92,*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  className="testimonials"*/}
        {/*>*/}
        {/*  {slice?.primary?.testimonials?.map((item, idx) => {*/}
        {/*    return (*/}
        {/*      <SwiperSlide key={idx}>*/}
        {/*        <div className="md:flex gap-x-[20px] items-start text-[#fff]">*/}
        {/*          <Image src={Quote} alt="Quote" width={43} height={33} />*/}
        {/*          <div className={"mt-5 md:mt-0"}>*/}
        {/*            <div className="mb-[22px]">*/}
        {/*              <PrismicRichText*/}
        {/*                field={item?.testimony}*/}
        {/*                components={bodyComponent}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*            <p className="text-base">-By {item?.name}</p>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </SwiperSlide>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</Swiper>*/}
      </div>
    </Container>
  );
};

export default testimonies;
